// removed by extract-text-webpack-plugin
module.exports = {"funeral-home-profile":"funeral-home-profile","head-container":"head-container","breadcrumbs":"breadcrumbs","breadcrumb-item":"breadcrumb-item","breadcrumb-link":"breadcrumb-link"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Shared/Breadcrumbs/css/Breadcrumbs.styl
// module id = 1579
// module chunks = 0